import fetchTopicTree from './action-topic-list';
import { fetchArticle } from '../../contactUs/actions/action-article';
import { resetRelatedArticle } from '../../contactUs/actions/action-related-article';
import { updateBreadCrumbFromArticleContent } from './action-breadcrumb';
import getCommunityResults from './action-community-posts';
import getOpenDisputes from './action-dispute-transactions';
import Page from '../../lib/page';
import poll from '../../lib/poll';
import { displayChatBot } from './action-chat-bot';
import { trackSetUp } from '../../lib/analytics-helper';
import { isC2MerchantMigrated } from '../../lib/globalHelper';

const validateFptiAndPAYPAL = () => {
  if (typeof window.fpti === 'undefined' || typeof window.PAYPAL === 'undefined') {
    return Promise.reject(false);
  }
  return Promise.resolve(window.fpti);
};

export default function fetchArticleContent(experience, faqid) {
  return (dispatch, getState) => {
    dispatch(resetRelatedArticle());
    const { topicList } = getState();
    if (topicList && topicList.topics && topicList.topics.length <= 0) {
      dispatch(fetchTopicTree(experience));
    }
    dispatch(fetchArticle(faqid, true))
      .then(() => {
        dispatch(displayChatBot());
        const response = getState().article.article;
        if (response) {
          poll(validateFptiAndPAYPAL, 5, 100)
            .then(() => trackSetUp({ id: 'articlePage', link: `smarthelp-article|${faqid}`, hpid: faqid }))
            .catch(() => {});
          dispatch(updateBreadCrumbFromArticleContent(response));
          if (!isC2MerchantMigrated()) {
            dispatch(getCommunityResults({ title: response.articleTitle, id: faqid }));
          }
          // checking articlemapped to condition if same article exists in multiple topics
          const articleMapped = response.articleMappedTo
            && Page.disputeBreadCrumb(response.articleMappedTo);

          // Validating remote config checks for article id, breadcrumbpath and articlemappedto
          if (Page.isLoggedIn() && response && (Page.disputeArticle(response.articleId)
            || articleMapped || Page.disputeBreadCrumb(response.breadCrumbPath))) {
            dispatch(getOpenDisputes());
          }
        } else {
          poll(validateFptiAndPAYPAL, 5, 100)
            .then(() => trackSetUp({ id: 'articleErrorPage', link: `smarthelp-error-article|${faqid}`, hpid: faqid }))
            .catch(() => {});
        }
      })
      .catch(() => {});
  };
}
